import React from 'react';

const TREND = {
  improving: { label: 'Improving', mark: '↑' },
  declining: { label: 'Declining', mark: '↓' },
  flat: { label: 'Flat', mark: '→' },
  insufficient_data: { label: 'Not enough audits to compare', mark: '–' },
};

export const trendView = (window) => {
  const direction = window?.direction || 'insufficient_data';
  const known = TREND[direction] || TREND.insufficient_data;
  const delta = window?.delta;
  let deltaText = '';
  if (typeof delta === 'number' && direction !== 'insufficient_data') {
    const sign = delta > 0 ? '+' : '';
    deltaText = `${sign}${delta} pts`;
  }
  return { ...known, deltaText };
};

const StatCard = ({ title, window }) => {
  const trend = trendView(window);
  const score = window?.average_score == null ? 'N/A' : window.average_score;
  return (
    <div className="rounded-md border border-gray-200 p-3">
      <div className="text-xs font-medium uppercase text-gray-500">{title}</div>
      <div className="mt-1 text-2xl font-semibold text-gray-900">{score}</div>
      <div className="text-xs text-gray-500">{window?.audit_count || 0} audits</div>
      <div className="mt-2 text-sm text-gray-800">
        <span aria-hidden="true">{trend.mark} </span>
        {trend.label}
        {trend.deltaText ? ` (${trend.deltaText})` : ''}
      </div>
    </div>
  );
};

export const ProgressEmailModal = ({
  preview,
  loading,
  sending,
  error,
  onCancel,
  onRefresh,
  onSend,
}) => (
  <div className="fixed inset-0 z-40 flex items-start justify-center overflow-y-auto bg-black/40 p-4">
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="progress-email-title"
      className="mt-10 w-full max-w-2xl rounded-lg bg-white shadow-xl"
    >
      <div className="border-b px-5 py-4">
        <h2 id="progress-email-title" className="text-lg font-semibold text-gray-900">
          Send progress email to {preview?.technician?.name || 'technician'}
        </h2>
        <p className="mt-1 text-sm text-gray-600">
          {preview?.recipient?.email || 'No email available in ServiceTitan'}
          {preview?.recipient?.email ? ' · ServiceTitan' : ''}
        </p>
      </div>
      <div className="space-y-4 px-5 py-4">
        {loading ? <p className="text-sm text-gray-600">Building preview…</p> : null}
        {error ? (
          <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-800">{error}</p>
        ) : null}
        {(preview?.warnings || []).map((warning) => (
          <p
            key={warning.code}
            className="rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-900"
          >
            {warning.message}
          </p>
        ))}
        {preview ? (
          <>
            <div className="grid gap-3 sm:grid-cols-2">
              <StatCard title="7 day" window={preview.statistics?.seven_day} />
              <StatCard title="30 day" window={preview.statistics?.thirty_day} />
            </div>
            <div>
              <div className="text-xs font-medium uppercase text-gray-500">Subject</div>
              <p className="mt-1 text-sm text-gray-900">{preview.email?.subject}</p>
            </div>
            <iframe
              title="Email preview"
              sandbox=""
              srcDoc={preview.email?.html || ''}
              className="h-80 w-full rounded border border-gray-200 bg-white"
            />
          </>
        ) : null}
      </div>
      <div className="flex justify-end gap-2 border-t px-5 py-3">
        <button
          type="button"
          className="rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="rounded-md border border-gray-300 px-3 py-1.5 text-sm text-gray-700 disabled:opacity-40"
          onClick={onRefresh}
          disabled={loading || sending}
        >
          Refresh Preview
        </button>
        <button
          type="button"
          className="rounded-md bg-blue-600 px-3 py-1.5 text-sm font-medium text-white disabled:opacity-40"
          onClick={onSend}
          disabled={!preview?.can_send || loading || sending}
        >
          {sending ? 'Sending…' : 'Send Email'}
        </button>
      </div>
    </div>
  </div>
);

export default ProgressEmailModal;
